// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import React from 'react';
import { WMComponent } from '@front/webmobile/Views/Components/WMComponent';
import { OrderInfoViewModel } from '../ViewModels/OrderInfoViewModel';
export class OrderInfoView extends WMComponent {
    constructor(props) {
        super(props, OrderInfoViewModel);
    }
    render() {
        const { orderIdLabel, fOrderId, instrumentLabel, fInstrumentName, showRoute, routeLabel, fRoute, orderTypeLabel, fOrderType, sideLabel, fSide, sideClass, leverageLabel, fLeverage } = this.state;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "order-info-view-container-label" },
                this.renderLabel(orderIdLabel),
                React.createElement("div", { className: "order-info-view-container-label-right" }, this.renderLabel(fOrderId))),
            React.createElement("div", { className: "order-info-view-container-label" },
                this.renderLabel(instrumentLabel),
                React.createElement("div", { className: "order-info-view-container-label-right" }, this.renderLabel(fInstrumentName))),
            showRoute && (React.createElement("div", { className: "order-info-view-container-label" },
                this.renderLabel(routeLabel),
                React.createElement("div", { className: "order-info-view-container-label-right" }, this.renderLabel(fRoute)))),
            React.createElement("div", { className: "order-info-view-container-label" },
                this.renderLabel(orderTypeLabel),
                React.createElement("div", { className: "order-info-view-container-label-right" },
                    this.renderLabel(fOrderType),
                    this.state.isAllowOTHTrading && this.renderIcon('overnight'))),
            React.createElement("div", { className: "order-info-view-container-label" },
                this.renderLabel(sideLabel),
                React.createElement("div", { className: "order-info-view-container-label-right" }, this.renderLabel(fSide, sideClass))),
            fLeverage && (React.createElement("div", { className: "order-info-view-container-label" },
                this.renderLabel(leverageLabel),
                React.createElement("div", { className: "order-info-view-container-label-right" }, this.renderLabel(fLeverage))))));
    }
    renderLabel(text, additionalClass = '') {
        const classesArr = ['js-tercera-label', additionalClass];
        const className = classesArr.join(' ');
        return React.createElement("div", { className: className }, text);
    }
    renderIcon(icon) {
        return (React.createElement("div", { className: "icon" },
            React.createElement("svg", null,
                React.createElement("use", { xlinkHref: `assets/webdesktop/web-desktop-sprite.svg#${icon}` }))));
    }
}
